
import { QuestionContent } from "@/types/test";
import { AudioRecorder } from "../media/AudioRecorder";

interface AudioQuestionProps {
  content: QuestionContent;
  response: string | null;
  onChange: (response: string | null) => void;
  questionId?: string;
  onUploadStateChange?: (isUploading: boolean) => void;
  isUploadInProgress?: boolean;
}

export function AudioQuestion({
  content,
  response,
  onChange,
  questionId,
  onUploadStateChange,
  isUploadInProgress = false,
}: AudioQuestionProps) {
  const handleRecordingComplete = (audioUrl: string) => {
    // Directly pass the audio URL to the parent through onChange
    console.log("Audio recording complete, URL:", audioUrl);
    onChange(audioUrl);
  };

  return (
    <div className="space-y-4">
      <h3 className="font-medium text-2xl text-foreground">{content.question}</h3>
      {!response ? (
        <AudioRecorder 
          onRecordingComplete={handleRecordingComplete}
          onUploadStateChange={onUploadStateChange}
        />
      ) : (
        <div className="space-y-2">
          <audio src={response} controls className="w-full" />
          <button
            onClick={() => onChange(null)}
            disabled={isUploadInProgress}
            className="text-sm text-destructive hover:underline disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {isUploadInProgress ? 'Upload in progress...' : 'Record again'}
          </button>
        </div>
      )}
    </div>
  );
}
